import { createFileRoute } from '@tanstack/react-router'
import { requireCapability } from '@/lib/auth'
import { RoutePending } from '@/components/route-pending'
import { RouteError } from '@/components/route-error'
import { reportRangeSearchSchema } from '@/features/reports/components/report-range-search'
import { CashPage } from '@/features/reports/pages/cash'

import type { ReportRangeSelection } from '@/types'

export const Route = createFileRoute('/_dashboard/analytics/cash')({
  beforeLoad: requireCapability('VIEW_REPORTS'),
  validateSearch: reportRangeSearchSchema,
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: CashRoute,
})

function CashRoute() {
  const selection = Route.useSearch()
  const navigate = Route.useNavigate()
  const onSelectionChange = (next: ReportRangeSelection) => navigate({ search: next, replace: true })
  return <CashPage selection={selection} onSelectionChange={onSelectionChange} />
}
